import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { ourNumbers } from "../../data";
import { Typography } from "@mui/material";
import achieve from "../../assets/traders2.jpg";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: "#fff",
	...theme.typography.body2,
	padding: theme.spacing(2),
	textAlign: "center",
	color: (theme.vars ?? theme).palette.text.secondary,
	...theme.applyStyles("dark", {
		backgroundColor: "#1A2027",
	}),
}));

export default function NumberUtil() {
	return (
		<Box sx={{ flexGrow: 1, mt: "1.5rem" }}>
			<img src={achieve} alt="achieve" className="w-full my-[1rem] h-auto" />
			<Grid
				container
				spacing={{ xs: 2, md: 3 }}
				columns={{ xs: 4, sm: 8, md: 12 }}>
				{ourNumbers.map((dt) => (
					<Grid
						key={dt.id}
						size={{
							xs: 2,
							sm: 4,
							md: 4,
						}}>
						<Item sx={{ bgcolor: "#E8F0FF", color: "black" }}>
							<Typography sx={{ fontSize: "1.1rem" }}>{dt.value}</Typography>
							<Typography sx={{ fontSize: "0.7rem", letterSpacing: "0.1rem" }}>
								{dt.name}
							</Typography>
						</Item>
						{/* <Item sx={{ color: "gray", fontSize: "0.9rem" }}>{dt.name}</Item> */}
					</Grid>
				))}
			</Grid>
		</Box>
	);
}
